import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { staticClass: "work-packages-container py-8", attrs: { fluid: "" } },
    [
      _c("alert-dialog", {
        attrs: {
          "is-open": _vm.isDeleteDialogOpen,
          "ok-btn-text": _vm.$t("actions.delete"),
        },
        on: { onOk: _vm.runDeleteWorkpackage, onCancel: _vm.closeDeleteDialog },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _vm._v(_vm._s(_vm.$t("dialogs.deleteWorkpackage.header"))),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("dialogs.deleteWorkpackage.body")) +
                    "\n      "
                ),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.workpackageToDelete
                        ? _vm.workpackageToDelete.description
                        : ""
                    )
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("transfer-dialog", {
        attrs: {
          "is-open": _vm.isTransferDialogOpen,
          "workpackage-to-transfer": _vm.workpackageToTransfer,
        },
        on: {
          onCancel: _vm.closeTransferDialog,
          onOk: _vm.runTransferWorkpackage,
        },
      }),
      _vm._v(" "),
      _c("alert-dialog", {
        attrs: {
          "is-open": _vm.isExportPricingDialogOpen,
          "is-max-height-fixed": true,
          "ok-btn-text": _vm.useSapExport
            ? _vm.$t(
                `workPackages.exportToSAP.${
                  _vm.sapExportParams.toFTP ? "exportToSystem" : "downloadFile"
                }`
              )
            : _vm.$t("actions.downloadPricing"),
        },
        on: { onOk: _vm.runExport, onCancel: _vm.closeExportPricingDialog },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.useSapExport
                        ? _vm.$t("workPackages.exportToSAP.title")
                        : _vm.$t("dialogs.downloadPricing.header")
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                !_vm.workpackageToExportPricing ||
                _vm.exporting(_vm.workpackageToExportPricing)
                  ? _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("general.loadingMessage")) +
                          "\n      "
                      ),
                    ])
                  : _c(
                      "div",
                      [
                        _vm.noProductsGoLiveAfterWorkpackage
                          ? _c("div", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "dialogs.downloadPricing.noProductsGoLiveAfterWP"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _c(
                              "div",
                              [
                                _c(
                                  VExpansionPanels,
                                  [
                                    _c(
                                      VExpansionPanel,
                                      [
                                        _c(
                                          VExpansionPanelHeader,
                                          {
                                            scopedSlots: _vm._u([
                                              {
                                                key: "actions",
                                                fn: function () {
                                                  return [
                                                    _c(VIcon, [
                                                      _vm._v("expand_more"),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "panel-header" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dialogs.downloadPricing.hasProductsGoLiveAfterWP"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          VExpansionPanelContent,
                                          _vm._l(
                                            _vm.sortedProductsGoLiveAfterWorkpackage,
                                            function (productKey, index) {
                                              return _c(
                                                "p",
                                                {
                                                  key: `productKey-${index}`,
                                                  staticClass: "mb-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(productKey) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "feature-toggle",
                          { attrs: { toggle: _vm.useManualProductGoLiveDate } },
                          [
                            _vm.noProductsGoLiveBeforeWorkpackage
                              ? _c("div", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "dialogs.downloadPricing.noProductsGoLiveBeforeWP"
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ])
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      VExpansionPanels,
                                      [
                                        _c(
                                          VExpansionPanel,
                                          [
                                            _c(
                                              VExpansionPanelHeader,
                                              {
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "actions",
                                                    fn: function () {
                                                      return [
                                                        _c(VIcon, [
                                                          _vm._v("expand_more"),
                                                        ]),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ]),
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "panel-header",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dialogs.downloadPricing.hasProductsGoLiveBeforeWP"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              VExpansionPanelContent,
                                              _vm._l(
                                                _vm.sortedProductsGoLiveBeforeWorkpackage,
                                                function (productKey, index) {
                                                  return _c(
                                                    "p",
                                                    {
                                                      key: `productKey-${index}`,
                                                      staticClass: "mb-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(productKey) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _vm.noProductsGoLiveBeforeToday
                              ? _c("div", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "dialogs.downloadPricing.noProductsGoLiveBeforeToday"
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ])
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      VExpansionPanels,
                                      [
                                        _c(
                                          VExpansionPanel,
                                          [
                                            _c(
                                              VExpansionPanelHeader,
                                              {
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "actions",
                                                    fn: function () {
                                                      return [
                                                        _c(VIcon, [
                                                          _vm._v("expand_more"),
                                                        ]),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ]),
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "panel-header",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dialogs.downloadPricing.hasProductsGoLiveBeforeToday"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              VExpansionPanelContent,
                                              _vm._l(
                                                _vm.sortedProductsGoLiveBeforeToday,
                                                function (productKey, index) {
                                                  return _c(
                                                    "p",
                                                    {
                                                      key: `productKey-${index}`,
                                                      staticClass: "mb-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(productKey) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        ),
                      ],
                      1
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("alert-dialog", {
        attrs: {
          "is-open": _vm.isExportAPIDialogOpen,
          "ok-btn-text": _vm.$t("actions.postPricing"),
        },
        on: { onOk: _vm.handleExportToAPI, onCancel: _vm.closeExportAPIDialog },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("dialogs.exportAPI.header")))]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", { attrs: { id: "export-api-warning" } }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("dialogs.exportAPI.warning"))),
                  ]),
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("dialogs.exportAPI.body")) +
                    "\n      "
                ),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.workpackageToExportAPI
                        ? _vm.workpackageToExportAPI.description
                        : ""
                    )
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "work-packages-header d-flex align-center" },
        [
          _c("h2", { staticClass: "panel-header flex-grow-1" }, [
            _vm._v(_vm._s(_vm.$t(_vm.heading))),
          ]),
          _vm._v(" "),
          _c(
            VBtn,
            {
              attrs: { icon: "" },
              on: { click: _vm.toggleWorkpackagesExpansion },
            },
            [_c(VIcon, [_vm._v(_vm._s(_vm.getExpansionIcon))])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.workpackagesExpanded,
              expression: "workpackagesExpanded",
            },
          ],
        },
        [
          !_vm.loading
            ? _c(
                "div",
                {
                  staticClass:
                    "work-packages-subheader mb-4 d-flex align-center",
                },
                [
                  _vm.searchWorkpackages
                    ? _c(
                        "div",
                        { staticClass: "search-wp-field-wrapper pr-4" },
                        [
                          _c(VTextField, {
                            staticClass: "search-wp-field search-field",
                            attrs: {
                              value: _vm.search,
                              "append-icon": "search",
                              label: _vm.$t("actions.search"),
                              "single-line": "",
                              loading: _vm.loading,
                            },
                            on: { input: _vm.debounceSearchUpdate },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "add-workpackage-btn-wrapper pl-2" },
                    [
                      _vm.canCreateWorkpackage
                        ? _c(
                            VBtn,
                            {
                              staticClass: "pa-0 new-workpackage-btn",
                              attrs: { text: "", "e2e-slug": "btnCreateWPNew" },
                              on: { click: _vm.createNewWorkpackage },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "icon-square" },
                                [
                                  _c(
                                    VIcon,
                                    { attrs: { small: "", color: "white" } },
                                    [_vm._v("mdi-plus")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "btn-label" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("workPackages.createNew"))
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "work-packages-list" }, [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "text-center my-4" },
                  [
                    _c(VProgressCircular, {
                      attrs: { indeterminate: "", color: "primary" },
                    }),
                  ],
                  1
                )
              : _vm.allWorkpackages.length === 0
              ? _c("div", { staticClass: "no-data-text" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("workPackages.noData")))]),
                ])
              : _c(
                  "div",
                  { staticClass: "workpackage-items" },
                  _vm._l(_vm.allWorkpackages, function (workpackage) {
                    return _c(
                      "div",
                      {
                        key: workpackage._id,
                        staticClass: "workpackage-item-wrapper",
                      },
                      [
                        _c("workpackage-item", {
                          attrs: {
                            workpackage: workpackage,
                            "is-selected":
                              workpackage._id === _vm.selectedWorkpackage._id,
                            "is-expanded": _vm.isExpanded(workpackage._id),
                            "max-unit-count": _vm.maxUnitCount,
                            "allow-copy": _vm.allowCopy,
                            "has-export-info": _vm.hasExportInfo,
                            "get-export-last-text": _vm.getExportLastText,
                            "column-formatters": _vm.columnFormatters,
                            fields: _vm.fields,
                          },
                          on: {
                            selectWorkpackage: _vm.selectWorkpackage,
                            "toggle-expansion": _vm.toggleExpansion,
                            "open-delete-dialog": _vm.openDeleteDialog,
                            "open-transfer-dialog": _vm.openTransferDialog,
                            "open-export-api-dialog": _vm.openExportAPIDialog,
                            "export-pricing": _vm.openExportPricingDialog,
                            "open-workpackage-copy-dialog":
                              _vm.openWorkpackageCopyDialog,
                            "trigger-download-export-to-sap":
                              _vm.triggerDownloadExportToSAP,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isCreateWorkpackageFromCopyEnabled &&
      _vm.allowCopy &&
      _vm.canEditWorkpackage
        ? _c("copy-workpackage-dialog", {
            attrs: {
              "is-open": _vm.isCopyWorkpackageDialogOpen,
              options: _vm.copyWorkpackageOptions,
            },
            on: {
              onOk: _vm.confirmCopyWorkpackage,
              onCancel: _vm.cancelCopyWorkpackage,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("create-workpackage-dialog", {
        attrs: { "is-open": _vm.showCreateDialog },
        on: {
          "update:isOpen": function ($event) {
            _vm.showCreateDialog = $event
          },
          "update:is-open": function ($event) {
            _vm.showCreateDialog = $event
          },
          created: _vm.handleWorkpackageCreated,
          cancel: function ($event) {
            _vm.showCreateDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }